import { API_KEY, LANG, REGION } from './const';

export async function getMovies() {
    try {
      const res = await fetch(
        `https://api.themoviedb.org/3/movie/now_playing?api_key=${API_KEY}&language=${LANG}&region=${REGION}`
      );
      let movies = await res.json();

      return movies.results;
      
    } catch (e) {
      console.log(e);
    }
}

export async function getMovieDetails(id) {
  try {
    const res = await fetch(
      `https://api.themoviedb.org/3/movie/${id}?api_key=${API_KEY}&language=${LANG}`
    );
    return await res.json();    
  } catch (e) {
    console.log(e);
  }
}


// WEBPACK FOOTER //
// ./src/utils/api.js